import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";

import { ReactComponent as LinkIcon } from "../../../assets/icons/links.svg";
import LottieAnimation from "../SuccessAnimation";

const Welcome = ({ step }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex h-full flex-1 flex-col justify-between py-12 reset-section">
        <div className="mt-10 md:mx-auto md:w-full md:max-w-xl sm:max-w-sm sm:w-full sm:mx-auto">
          <div className="md:mx-auto">
            <Link to="/">
             <Logo/>
            </Link>
          </div>

          <div className="max-w-lg lg:py-5 mx-auto ">
            <LottieAnimation />
            <h4 className="font-heading text-h3 text-primary font-bold mb-4 text-center">
              Password changed successfully
            </h4>
          </div>
          <button
            onClick={() => {
              navigate("/login");
            }}
            className="flex w-full justify-center rounded-md bg-primary px-3 py-3 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mb-5"
          >
            Back to login
          </button>
        </div>

        <div>
          <p>{`Copyright @ ${new Date().getFullYear()} TREVEX, Inc`} </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center mr-2 gap-2 font-bold"
          >
            Privacy Policy <LinkIcon />{" "}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Welcome;
